"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingScreen = void 0;
const gsap_1 = require("gsap");
class LoadingScreen {
    static init() {
        const heroOverflowElem = document.querySelector('.hero-overflow');
        const videoElem = document.querySelector('.hero-overflow video');
        const loadingElem = document.querySelector('.loading-screen');
        const viewW = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        if (!document.body.classList.contains('home') || heroOverflowElem == null || viewW <= 991) {
            loadingElem ? loadingElem.classList.add('force') : '';
            videoElem === null || videoElem === void 0 ? void 0 : videoElem.play();
            return;
        }
        videoElem.addEventListener('loadeddata', () => {
            const checkReady = () => {
                if (videoElem.readyState === 4) {
                    this.startAnimation();
                }
                else {
                    setTimeout(checkReady, 50);
                }
            };
            checkReady();
        });
    }
    static startAnimation() {
        const videoElem = document.querySelector('.hero-overflow video');
        if (!videoElem) {
            return;
        }
        const tl = gsap_1.gsap.timeline({
            onStart: () => {
                var _a;
                document.body.classList.add('no-scroll');
                (_a = document.querySelector('.navbar-default')) === null || _a === void 0 ? void 0 : _a.classList.add('transparent');
            },
        });
        tl.to('.loading-screen img', { alpha: 0, delay: 0.5 });
        tl.to('.loading-screen', { translateX: '-100%', delay: 0.5 });
        videoElem.play();
    }
}
exports.LoadingScreen = LoadingScreen;
